<div [id]="reactWrapperId">
    <!-- React component will be rendered inside this div -->
</div>